const types = {
	RESET_ALL: 'RESET_ALL',
	FETCH_ITEM: 'FETCH_ITEM',
	FETCH_ITEM_ERROR: 'FETCH_ITEM_ERROR',
	FETCH_ITEM_START: 'FETCH_ITEM_START',
	FETCH_PENDING_BIDS: 'FETCH_PENDING_BIDS',
	FETCH_PENDING_BIDS_ERROR: 'FETCH_PENDING_BIDS_ERROR',
	FETCH_PENDING_BIDS_START: 'FETCH_PENDING_BIDS_START',
	DELETE_ITEM: 'DELETE_ITEM',
	DELETE_ITEM_ERROR: 'DELETE_ITEM_ERROR',
	LAST_CREATED_ITEM: 'LAST_CREATED_ITEM',
	UPDATE_ITEM: 'UPDATE_ITEM',
	UPDATE_ITEM_ERROR: 'UPDATE_ITEM_ERROR',
	UPDATE_ITEM_START: 'UPDATE_ITEM_START',
	MOVE_ITEM: 'MOVE_ITEM',
	MOVE_ITEM_ERROR: 'MOVE_ITEM_ERROR',
	MOVE_ITEM_START: 'MOVE_ITEM_START',
	CREATE_ITEM: 'CREATE_ITEM',
	CREATE_ITEM_ERROR: 'CREATE_ITEM_ERROR',
	UPLOAD_MEDIA: 'UPLOAD_MEDIA',
	UPLOAD_MEDIA_START: 'UPLOAD_MEDIA_START',
	UPLOAD_MEDIA_ERROR: 'UPLOAD_MEDIA_ERROR',
	DELETE_MEDIA_START: 'DELETE_MEDIA_START',
	DELETE_MEDIA_SUCCESS: 'DELETE_MEDIA_SUCCESS',
	DELETE_MEDIA_ERROR: 'DELETE_MEDIA_ERROR',
	RESET_LAST_CREATED_ITEM: 'RESET_LAST_CREATED_ITEM',
};

export default types;


// WEBPACK FOOTER //
// ./src/store/modules/item/mutation-types.js